import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations";

/**
 * ServiceCollectionLogoV2
 *
 * Previously rendered "Service collection" as SVG text paths (image of text),
 * violating WCAG 1.4.5. Now uses real HTML text with the yellow blob shape
 * as a decorative SVG (aria-hidden) to ensure text is accessible, resizable,
 * and customisable by assistive technologies.
 */
export const ServiceCollectionLogoV2 = () => (
    <div css={containerCss}>
        {/* Decorative yellow blob shape - hidden from screen readers */}
        <svg viewBox="0 0 108 64" css={blobCss} fill="none" aria-hidden={true}>
            <path
                fill="#FFC716"
                d="m1.755 5.022 105.992 3.701-1.755 50.256L0 55.277z"
            />
        </svg>
        {/* Real HTML text replacing the former SVG text paths */}
        <span css={textCss}>Service collection</span>
    </div>
);

const containerCss = css({
    display: "flex",
    alignItems: "center",
    gap: "8px",
    height: 48,
    width: "auto",
    ["@media (min-width: 64rem)"]: {
        height: 64
    }
});

const blobCss = css({
    height: "100%",
    width: "auto",
    flexShrink: 0
});

const textCss = css({
    fontFamily: wacToken("font.charlie.display"),
    fontSize: "1.5rem",
    fontWeight: 700,
    color: wacToken("color.primary.black"),
    whiteSpace: "nowrap",
    lineHeight: 1,
    ["@media (min-width: 64rem)"]: {
        fontSize: "2rem"
    }
});
